// import logo from './logo.svg';
import './App.css';
import Fgodle from './Fgodle';

function App() {
  return (
    <div className="App">
      {/* <header className="App-header">
      </header> */}
      <body className="App-body" >
        <Fgodle/>
      </body>
    </div>
  );
}

export default App;
